// extracted by mini-css-extract-plugin
export default {"loader":"Loader_loader__DwtSp","rotate":"Loader_rotate__NEbL0","prixClipFix":"Loader_prixClipFix__vlkTY"};